document.addEventListener('DOMContentLoaded', function () {
    let attempts = 0;
    const maxAttempts = 20; 
    
    const checkElement = setInterval(() => {
        const toggleSwitch = document.querySelector('#upCart .styles_ToggleSwitch__');
        if (toggleSwitch) {
            toggleSwitch.click();
            clearInterval(checkElement);
        } 
        
        attempts++;
        if (attempts >= maxAttempts) {
            clearInterval(checkElement);
        }
    }, 500); 
});
